module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: QHbCMC_Czjs\n\n## Notes\nEsmeralda and Goober meet the Systems Manager (5:23).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level5_opening.md
// module id = 1839
// module chunks = 2